import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Table, TableData, TableHeader, TableRow } from '../../../base/table/table';
import * as StyledLetterPostboxesTable from './letterPostboxesTable.styles';

interface Props {
	data: any;
}

const LetterPostboxesTable: FC<Props> = ({ data }) => {
	const { t } = useTranslation('generalPostInfo');
	if (!data) return null;

	return (
		<StyledLetterPostboxesTable.Wrapper>
			<Table>
				<TableRow>
					<TableHeader mobile={1 / 3}>{t('letter-postbox.zip')}</TableHeader>
					<TableHeader mobile={1 / 3}>{t('letter-postbox.address')}</TableHeader>
					<TableHeader mobile={1 / 3}>{t('letter-postbox.name')}</TableHeader>
				</TableRow>
				{data.map(postcode => (
					<TableRow key={postcode.id}>
						<TableData mobile={1 / 3}>{`${postcode.postCode} ${postcode.city}`}</TableData>
						<TableData mobile={1 / 3}>{postcode.address}</TableData>
						<TableData mobile={1 / 3}>{postcode.name}</TableData>
					</TableRow>
				))}
			</Table>
		</StyledLetterPostboxesTable.Wrapper>
	);
};

export default LetterPostboxesTable;
